<template>
    <div class="ses-modal-wrap" v-if="floordata" id="FloorInfo">
        <a class="ses-modal-bd" @click="closeModal"></a>
        <div class="ses-modal" style="width: 1170px;">
            <div class="ses-modal-head"> Floor Information for Car {{ floordata.cn }}</div>
            <div class="ses-modal-body">
                <form id="floor-form" >
                    <input type="hidden" v-model="step">
                    <table id="floor-table">
                        <thead>
                            <tr>
                                <th>Floor #</th>
                                <th>Floor Markings *</th>
                                <th>Floor Openings *</th>
                                <th>Floor Lockout</th>
                                <th>Short Floors (ft)<br><small>Distance to the Next Floor</small></th>
                                <th>Fire Return Floor</th>
                                <th>Fire Alternate Floor</th>
                            </tr>
                        </thead>
                        <tbody id="floor-info-list">
                            <tr v-for="(floor,f) in floors" :key="f">
                                <td class="flr-num">{{ f+1 }}</td>
                                <td class="flr-marking"><input type="text" v-model="floor.floor_markings" ref="marking" class="marking" required></td>
                                <td class="flr-rear">
                                    <label><input type="radio" class="rear" :name="'rear['+f+']'" v-model="floor.floor_opening" value="Front" checked=""> Front</label>
                                    <label><input type="radio" class="rear" :name="'rear['+f+']'" v-model="floor.floor_opening" value="Back"> Back</label>
                                    <label><input type="radio" class="rear" :name="'rear['+f+']'" v-model="floor.floor_opening" value="Both"> Both</label>
                                </td>
                                <td class="flr-short">
                                    <select v-model="floor.floor_lockout" :disabled="floordata.ctrl.floor_lockout == 'No'">
                                        <option>Yes</option>
                                        <option>No</option>
                                    </select>
                                </td>
                                <td class="flr-short"><input type="text" v-model="floor.short_fl_dist_to_next" class="short"></td>
                                <td class="flr-return">
                                    <select v-model="floor.fire_return_floor">
                                        <option>Yes</option>
                                        <option>No</option>
                                    </select>
                                </td>
                                <td class="flr-alternate">
                                    <select v-model="floor.fire_alternate_floor">
                                        <option>Yes</option>
                                        <option>No</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Note:</td>
                                <td colspan="6">
                                    <textarea rows="3" class="note" v-model="notes"></textarea>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </form>
            </div>
            <div class="ses-modal-foot">
                <a class="btn btn-black" @click="saveFloors">Save Info</a>
            </div>
        </div>
    </div>
</template>
<script>

  export default {
    name: "floorInfo",
    props: {
      floordata: {
        type: [String, Object, Array, Boolean],
        default: "",
        description: "Model"
      },
    },
    data() {
      return {
        notes: '',
        step: 1,
        toggled: false,
        reseter    : { counter : 1 },
        floors: [],
        floor: {
            car_num : 1,
            floor_no : 1,
            floor_markings : '',
            floor_opening : 'Front',
            short_fl_dist_to_next : '',
            fire_return_floor : '',
            fire_alternate_floor : '',
        }
      };
    },
    watch: {
        floordata: {
            handler: function(data) {
                var i = 0;
                var fl = {};
                if ( data ) {
                    if ( data.ctrl.floor_info ) {
                        var floors = data.ctrl.floor_info;

                        if ( floors.length > data.ctrl.no_of_floors ) {
                            floors.splice(data.ctrl.no_of_floors,floors.length-data.ctrl.no_of_floors);
                        } else if ( floors.length < data.ctrl.no_of_floors ) {
                            for (i = floors.length; i < data.ctrl.no_of_floors; i++) {
                                floors[i] = { ...this.floor, ...{ car_num : data.cn, floor_no : i+1 } };
                            }
                        }

                        this.floors = floors;

                    } else {
                        this.floors = [];
                        for (var f = 0; f < data.ctrl.no_of_floors; f++) {
                            if ( this.floordata.ctrl.floor_lockout == 'No' ) fl = { floor_lockout : '' };
                            this.floors[f] = { ...this.floor, ...{ car_num : this.floordata.cn, floor_no : f+1 }, ...fl };
                        }
                    }
                    this.notes = data.ctrl.notes ? data.ctrl.notes : '';
                }

            },
            deep: true
        }
    }, 
    methods: {
        checkData(){
            var hasEmpty = false,
                firstEl = false,
                item = false;

            for(var i in this.$refs) {
                const _el = this.$refs[i];
                if ( Array.isArray(_el) ) {
                    for (var x in _el) {
                        item = _el[x];
                        if ( item && !item.disabled && item.value == '' ) {
                            hasEmpty = true;
                            if ( !firstEl ) firstEl = item;
                        }
                    }
                } else {
                    item = _el;
                    if ( item && !item.disabled && item.value == '' ) {
                        hasEmpty = true;
                        if ( !firstEl ) firstEl = item;
                    }
                }
            }

            Array.from(document.querySelectorAll('.has-error')).forEach(function(el) { 
                el.classList.remove('has-error');
            });

            if ( hasEmpty ) {
                alert('Please fill all required data.');
                firstEl.focus();
                firstEl.classList.add('has-error');
                return false;
            }
            return true;
        },
        closeModal() {
            if ( confirm('Data changes will be lost if not saved.') ) {
                this.$emit('closeinfo');
            }
        },
        showItems() {
            ++this.step;
        },
        saveFloors() {
            if ( !this.checkData() ) return false;

            this.$emit('saveinfo', {
                cn : this.floordata.cn,
                ctrl : { ...this.floordata.ctrl, ...{ floor_info : this.floors, notes : this.notes } }
            });

            this.$emit('closeinfo');
        }
    }
};
</script>
<style>
    .ses-modal-wrap { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 99999; }
    .ses-modal-bd { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,.5); }
    .ses-modal { position: absolute; top: 50%; left: 50%; width: 940px; max-width: calc(100% - 60px); height: auto; transform: translate(-50%,-50%); background: #FFF; border-radius: 6px; overflow: hidden; }
    .ses-modal-head { color: #fff; font-size: 19px; text-shadow: 1px 1px 3px #000; text-align: center; background: #333; padding: 14px 20px; min-height: 16.43px; }
    .ses-modal-body { position: relative; padding: 15px; max-height: calc(100vh - 160px); overflow: auto; }
    .ses-modal-foot { padding: 15px; text-align: right; border-top: 1px solid #e5e5e5; }
    .modal-step { padding: 0 15px; }

    #FloorInfo table { width: 100%; }
    #FloorInfo th, #FloorInfo td { padding: 4px 10px; border: 1px solid #333; white-space: nowrap; }
    #FloorInfo thead th, #FloorInfo tbody td { text-align: center; }
    #FloorInfo table input[type="text"],
    #FloorInfo table select,
    #FloorInfo table textarea { width: calc(100% + 22px); border-radius: 0px !important; box-shadow: none; border: 1px solid #333; margin: -5px -11px; padding: 4px 10px; display: block; height: 26px; }
    #FloorInfo table textarea { resize: vertical; min-height: 64px; }
    #FloorInfo table label { display: inline-block; margin: -4px 4px; font-weight: normal; }
    #FloorInfo table [disabled] { background: #b5b5b5 !important; opacity: 1 !important; }
    #FloorInfo .has-error{ outline: 1px solid red !important; z-index: 2 !important; background: #ffe9e9 !important; border-color: red !important; }
</style>